const initialLeagueList = [
  { sport: 'Soccer', league: 'Euro 2024 Matches' },
  { sport: 'Soccer', league: 'EURO 2024 - Knockout Stage' },
  { sport: 'Soccer', league: 'EPL' },
  { sport: 'Baseball', league: 'MLB' },
]

export default initialLeagueList